import tw from "twin.macro"

const Description = tw.div`pt-12 text-justify lg:text-xl whitespace-pre-line`

export default Description